import { useQuery } from '@tanstack/react-query';

import { TransactionsApi } from '../../apis';
import { QueryKeys } from '../query-keys';

const useTransactions = (page = 1, perPage = 10, filter = {}) => {
  const query = useQuery({
    queryKey: [QueryKeys.TRANSACTIONS, page, perPage, filter],
    queryFn: () => TransactionsApi.getPage({ page, perPage, filter }),
  });

  return {
    isLoading: query.isPending,
    hasError: query.isError,
    page: query.data?.page || 1,
    perPage: query.data?.perPage || 10,
    total: query.data?.total || 0,
    totalPages: query.data?.totalPages || 0,
    transactions: query.data?.transactions || [],
    filter,
  };
};

export default useTransactions;
